/**
 * Basic shift time rules — aligned with advance mode (incl. 24h same-clock window).
 */
import {
  ADVANCE_FIELD_REQUIRED_MSG,
  ADVANCE_SHIFT_ZERO_DURATION_MSG,
  ADVANCE_SPLIT_SAME_TIME_MSG,
  getAdvanceDurationLabel,
  getAdvanceShiftLengthDisplay,
  getAdvanceShiftWindowMinutes,
  isAdvanceSameClockTimeFullDay,
  isAdvanceShiftZeroDuration,
  validateAdvanceShiftEndTime,
  validateAdvanceSplitEndTime,
} from "./advanceModeValidation";

export {
  ADVANCE_FIELD_REQUIRED_MSG as BASIC_FIELD_REQUIRED_MSG,
  ADVANCE_SHIFT_ZERO_DURATION_MSG as BASIC_SHIFT_ZERO_DURATION_MSG,
  ADVANCE_SPLIT_SAME_TIME_MSG as BASIC_SPLIT_SAME_TIME_MSG,
  isAdvanceSameClockTimeFullDay as isBasicSameClockTimeFullDay,
  isAdvanceShiftZeroDuration as isBasicShiftZeroDuration,
  validateAdvanceShiftEndTime as validateBasicShiftEndTime,
  validateAdvanceSplitEndTime as validateBasicSplitEndTime,
  getAdvanceShiftWindowMinutes as getBasicShiftWindowMinutes,
  getAdvanceShiftLengthDisplay,
  getAdvanceDurationLabel as getBasicDurationLabel,
};

/** Duration as "HH:MM" for split-shift total validation (supports 24h window). */
export const getBasicShiftDurationHHMM = (startTime, endTime) => {
  const minutes = getAdvanceShiftWindowMinutes(startTime, endTime);
  if (minutes == null) return null;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};

const hasServiceCategoryValue = (value) =>
  value != null && String(value).trim() !== "";

/**
 * Hard-gate Service Category for basic create/update.
 * Does not depend on react-select/RHF mount state (Select remounts skip required).
 * Returns list of invalid field paths (empty when valid).
 */
export const getMissingBasicServiceCategoryPaths = (
  formValues = {},
  { isShiftSplit = false } = {}
) => {
  const missing = [];
  const splits = Array.isArray(formValues.splitShifts)
    ? formValues.splitShifts
    : [];

  if (isShiftSplit && splits.length > 0) {
    splits.forEach((split, index) => {
      if (!hasServiceCategoryValue(split?.invoice_service_type_id)) {
        missing.push(`splitShifts.${index}.invoice_service_type_id`);
      }
    });
    return missing;
  }

  if (!hasServiceCategoryValue(formValues.invoice_service_type_id)) {
    missing.push("invoice_service_type_id");
  }
  return missing;
};
